import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { patchState, signalStore, withMethods, withState } from '@ngrx/signals';
import { DeviantRekenmoduleVoucherService } from '@thiememeulenhoff/ng-api-gateway';
import { firstValueFrom } from 'rxjs';
import {
  toRequestError,
  withRequestStatus,
} from '../_utils/request-status.feature';

type VoucherModalState = {
  voucherCode: string | undefined;
  validUntil: string | undefined;
  poolExhausted: boolean;
};

const VoucherModalStore = signalStore(
  { providedIn: 'root' },
  withState<VoucherModalState>({
    voucherCode: undefined,
    validUntil: undefined,
    poolExhausted: false,
  }),
  withRequestStatus(),
  withMethods(
    (store, voucherService = inject(DeviantRekenmoduleVoucherService)) => ({
      async fetchVoucher(): Promise<void> {
        patchState(store, {
          requestStatus: 'loading',
          voucherCode: undefined,
          validUntil: undefined,
          poolExhausted: false,
        });

        try {
          const { voucherCode, validUntil } = await firstValueFrom(
            voucherService.fetchVoucher(),
          );
          patchState(store, {
            voucherCode,
            validUntil,
            requestStatus: 'success',
          });
        } catch (error: unknown) {
          if (error instanceof HttpErrorResponse && error.status === 422) {
            patchState(store, {
              poolExhausted: true,
              requestStatus: toRequestError(error),
            });
            return;
          }

          patchState(store, { requestStatus: toRequestError(error) });
        }
      },
    }),
  ),
);

export default VoucherModalStore;
